import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import LogoutButton from './LogoutButton';

const AdminLayout = ({ children }) => {
  const { pathname } = useLocation();

  const isActive = (path) =>
    pathname === path ? 'fw-bold text-decoration-underline' : '';

  return (
    <div className='container py-4'>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h2 className='fw-bold m-0'>Admin Panel</h2>
        <LogoutButton />
      </div>

      {/* Navigation between sections */}
      <nav className='d-flex justify-content-center gap-4 mb-4 border-bottom pb-2'>
        <Link
          to='/admin/staff'
          className={`text-dark ${isActive('/admin/staff')}`}
        >
          Staff
        </Link>
        <Link
          to='/admin/blog'
          className={`text-dark ${isActive('/admin/blog')}`}
        >
          Blog
        </Link>
        <Link
          to='/admin/gallery'
          className={`text-dark ${isActive('/admin/gallery')}`}
        >
          Gallery
        </Link>
        <Link
          to='/admin/contactMessages'
          className={`text-dark ${isActive('/admin/contactMessages')}`}
        >
          Messages
        </Link>

        {/* Add more links here if needed */}
      </nav>

      {children}
    </div>
  );
};

export default AdminLayout;
